import { useState, useEffect, useContext } from "react";
import { loginContext, customerContext } from "../../context/contexts";
import { getKeyByValue } from "../../context/contextmanager";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Box, TextField, MenuItem } from "@mui/material";
import { Button } from "@mui/material";
import { getobj, updateobj, dltobj, postobj } from "../../apicall/apicall";
import { useLocation } from "react-router-dom";
import { timeStamp } from "../../apicall/commonFunction";
import { Switch } from "@mui/material";
import {
  StyledTableRow,
  StyledTableCell,
  buttonPosition,
  boxStyle,
  buttonStyle3,
} from "../../style/style";

import ArrowBack from "@mui/icons-material/ArrowBack";
import "react-notifications/lib/notifications.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import Pagination from "@mui/material/Pagination";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

export default function HubDevices(props) {
  const [devices, setdevice] = useState();
  const [page, setpage] = useState(
    sessionStorage.getItem("page_number")
      ? parseInt(sessionStorage.getItem("page_number"))
      : 1,
  );
  const [totalpage, setpaget] = useState();
  const [billingType, setBillingType] = useState([]);
  const [freePeriodType, setFreePeriodType] = useState([]);
  const [refresh, setrefresh] = useState(false);
  const [open, setopen] = useState(false);
  const [model, setmodel] = useState();
  const context = useContext(loginContext);
  const [loaded, setloaded] = useState(true);
  const isAdmin = localStorage.getItem("role") === "ADMIN";
  const [update_device, setupdate_device] = useState({
    customer_id: props.id,
    device_group: "",
    mac_address: "",
    billing_type_id: 1, // Default billing type Monthly
    imei_number: "NA",
    device_name: "",
    device_type: "BLUETOOTH",
    comments: "",
    active_status: false,
    hub_id: context.hub,
  });

  const resetdata = {
    customer_id: props.id,
    device_group: "",
    mac_address: "",
    imei_number: "NA",
    device_name: "",
    device_type: "BLUETOOTH",
    comments: "",
    active_status: false,
    hub_id: context.hub,
  };
  const handlePagechange = (event, value) => {
    setloaded(true);
    let url = "";
    if (props.search !== "") {
      url =
        process.env.REACT_APP_ZEWA_URL +
        "device/get-device/0/" +
        "?page=" +
        value +
        "&hub=" +
        context.hub +
        "&seach=" +
        props.search;
    } else {
      url =
        process.env.REACT_APP_ZEWA_URL +
        "device/get-device/0/" +
        "?page=" +
        value +
        "&hub=" +
        context.hub;
    }
    const d = getobj(url);
    d.then(function (res) {
      setloaded(false);

      setpage(value);

      setdevice(res.results);
    });
  };

  const handleChange2 = (e) => {
    const { name, value } = e.target;

    if (name === "active_status") {
      setupdate_device({
        ...update_device,
        active_status: e.target.checked,
      });
    } else {
      if (name === "device_group") {
        const dev_name = model.find((i) => i.id === value).device_name;
        setupdate_device({
          ...update_device,
          device_name: dev_name,
          device_group: value,
        });
      } else {
        setupdate_device({
          ...update_device,
          [name]: value,
        });
      }
    }
  };
  function validate(data) {
    console.log(data);
    let res = true;
    const not_null = Object.keys(data).map((i) => {
      if (i === "comments" || i === "imei_number") {
        return true;
      } else if (data[i] === "NA" || data[i] === "") {
        console.log(i);
        return false;
      }
      return true;
    });
    for (let i = 0; i < not_null.length; i++) {
      res = res && not_null[i];
    }

    console.log(res);
    return res;
  }
  const handleSubmit = () => {
    console.log(props);
    if (validate(update_device)) {
      const url = process.env.REACT_APP_ZEWA_URL + "device/add-device/";
      const res = postobj(url, update_device);
      res.then(function (d) {
        if (d.status === 201) {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success(d.Message, "Success", 2000);
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error(d.Message, "Failed", 2000);
        }
        setupdate_device(resetdata);
        setopen(false);
        setrefresh(!refresh);
      });
    } else {
      NotificationManager.remove(NotificationManager.listNotify[0]);

      NotificationManager.error("Please fill the form correctly");
    }
  };

  const context2 = useContext(customerContext);
  const loc = useLocation();
  useEffect(() => {
    console.log(page, "page");
    let url;
    setupdate_device({
      ...update_device,
      hub_id: context.hub,
    });
    if (props.search === "") {
      url =
        process.env.REACT_APP_ZEWA_URL +
        "device/get-device/0/" +
        "?hub=" +
        context.hub;
    } else {
      url =
        process.env.REACT_APP_ZEWA_URL +
        "device/get-device/" +
        props.id +
        "/?search=" +
        props.search +
        "&status=CONNECTED";
      setpage(1);
    }
    const d = getobj(url);
    d.then(function (res) {
      if (res.count % 5 > 0) {
        setpaget(Math.floor(res.count / 5) + 1);
      } else {
        setpaget(Math.floor(res.count / 5));
      }
      setdevice(res.results);
      setloaded(false);
    });
    const url2 = process.env.REACT_APP_ZEWA_URL + "device/addDeviceGroup/";
    const d2 = getobj(url2);
    d2.then(function (res) {
      setmodel(res);
    });
  }, [refresh]);
  const handleClick = (id) => {
    if (loc.pathname === "/admin") {
      context.setid(id);
      const nm = getKeyByValue(context.page, true);
      sessionStorage.setItem("page_number", page);
      context.setpage({
        ...context.page,
        [nm]: false,
        deviceDetail: true,
      });
    } else if (loc.pathname === "/customer") {
      context.setid(id);
      sessionStorage.setItem("page_number", page);

      const nm = getKeyByValue(context2.manage, true);
      context2.setmanage({
        ...context2.manage,
        [nm]: false,
        deviceDetail: true,
      });
    } else if (loc.pathname === "/user") {
      context.setid(id);
      const nm = getKeyByValue(context2.manage, true);
      sessionStorage.setItem("page_number", page);

      context2.setmanage({
        ...context2.manage,
        [nm]: false,
        deviceDetail: true,
      });
    } else if (
      loc.pathname === "/distributor" ||
      loc.pathname === "/distributor-user"
    ) {
      context.setid(id);
      props.detail.setdevicedetail(true);
      sessionStorage.setItem("page_number", page);
    }
  };
  const handleaction = (id, val, type, mac_address, hub) => {
    // console.log(id, val);

    if (val === "Detail") {
      sessionStorage.setItem("page", "hubDevice");
      sessionStorage.setItem("value", 5);
      sessionStorage.setItem("hub_d", true);
      handleClick(id);
    } else if (val === "unlink") {
      const url =
        process.env.REACT_APP_ZEWA_URL +
        "hub/connect/0/?mac_address=" +
        mac_address +
        "&action=unlink&hub_id=" +
        hub;
      updateobj(url, {}).then(function (res) {
        if (res.status === 200) {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success(res.Message, 2000);
          setrefresh(!refresh);
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error(res.Message, "Unlinked", 2000);

          setrefresh(!refresh);
        }
      });
    } else if (val === "Delete") {
      if (type === "NA") {
        alert("Are you sure! The device will be deleted");
      } else {
        alert(
          "The Device and sim will be deactivated. To delete it permanently please contact admin.",
        );
      }
      const url = process.env.REACT_APP_ZEWA_URL + "device/add-device/";
      const res = dltobj(url, { id: id });
      res.then((r) => {
        if (r["Message"] === "Device deleted successfully") {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success("Successfully deleted.", "Deleted", 2000);
          setrefresh(!refresh);
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Could not deletd.", "Failed", 2000);
        }
      });
    } else {
      const url = process.env.REACT_APP_ZEWA_URL + "device/add-device/";
      let status;
      if (val === "Activate") {
        status = true;
      } else {
        status = false;
      }
      const data = { id: id, active_status: status };
      const res = updateobj(url, data);
      res.then(function (data) {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.success("Status Updated.", "Updated", 2000);

        setrefresh(!refresh);
      });
      //console.log(data);
    }
  };
  const handleBack = () => {
    sessionStorage.setItem("value", null);
    sessionStorage.setItem("hub_d", false);
    sessionStorage.setItem("page_number", 1);
    props.sethub_d(false);
    props.sethub_id("");
  };

  useEffect(() => {
    let url = process.env.REACT_APP_ZEWA_URL + "user/billing-type/";
    const d = getobj(url);
    d.then(function (res) {
      setBillingType(res);
    });
  }, []);

  useEffect(() => {
    let url = process.env.REACT_APP_ZEWA_URL + "device/free-period-types/";
    const d = getobj(url);
    d.then(function (res) {
      setFreePeriodType(res);
    });
  }, []);

  return (
    <div>
      <Box sx={boxStyle}>
        {
          <Button
            sx={{ float: "left" }}
            onClick={handleBack}
            startIcon={<ArrowBack />}
          ></Button>
        }
        <Box sx={buttonPosition}>
          <Button
            sx={buttonPosition}
            variant="contained"
            color="primary"
            onClick={() => {
              setopen(true);
            }}
          >
            add device
          </Button>
        </Box>
        <Box sx={{ marginRight: "30px" }}>
          {loaded ? (
            <img
              src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif"
              alt="loading..."
            />
          ) : devices && devices.length > 0 ? (
            <Box>
              <TableContainer>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>
                        <b>Device Group</b>
                      </StyledTableCell>
                      <StyledTableCell>
                        <b>Model</b>
                      </StyledTableCell>
                      <StyledTableCell>
                        <b>Bluetooth ID</b>
                      </StyledTableCell>
                      <StyledTableCell>
                        <b>IMEI</b>
                      </StyledTableCell>
                      <StyledTableCell>
                        <b>Status</b>
                      </StyledTableCell>
                      <StyledTableCell>
                        <b>Last Active</b>
                      </StyledTableCell>
                      <StyledTableCell>
                        <b> Comments</b>
                      </StyledTableCell>
                      <StyledTableCell></StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {devices &&
                      devices.map((device) => (
                        <StyledTableRow key={device.id}>
                          <StyledTableCell>{device.group}</StyledTableCell>
                          <StyledTableCell>{device.model}</StyledTableCell>
                          <StyledTableCell>
                            {device.mac_address}
                          </StyledTableCell>
                          <StyledTableCell>
                            {device.imei_number}
                          </StyledTableCell>
                          <StyledTableCell>
                            {device.active_status === false
                              ? "Inactive"
                              : "Active"}
                          </StyledTableCell>
                          <StyledTableCell>
                            {device.imei_number === "NA"
                              ? timeStamp(parseInt(device.utc))
                              : timeStamp(parseInt(device.utc, 16))}
                            {/* {device.last_active.split("T")[0]} */}
                          </StyledTableCell>
                          <StyledTableCell>{device.comments}</StyledTableCell>
                          <StyledTableCell>
                            <Button
                            // variant="contained"
                            // onClick={() => {
                            //   handleClick(device.id);
                            // }}
                            >
                              <TextField
                                select
                                name="device_name"
                                id="deviceName"
                                sx={{ width: "clamp(80px, 12vw, 100px)" }}
                                variant="outlined"
                                label="Action"
                                // s
                                onChange={(e) => {
                                  handleaction(
                                    device.id,
                                    e.target.value,
                                    device.imei_number,
                                    device.mac_address,
                                    device.hub_id === null
                                      ? "NA"
                                      : device.hub_id["hub_id"],
                                  );
                                }}
                              >
                                <MenuItem value="Detail">Detail</MenuItem>
                                <MenuItem
                                  value={
                                    device.active_status
                                      ? "Deactivate"
                                      : "Activate"
                                  }
                                >
                                  {device.active_status
                                    ? "Deactivate"
                                    : "Activate"}
                                </MenuItem>

                                {loc.pathname === "/admin" && (
                                  <MenuItem value="Delete">Terminate</MenuItem>
                                )}
                                {device.imei_number === "NA" && (
                                  <MenuItem
                                    value={device.hub_id ? "unlink" : "link"}
                                  >
                                    {device.hub_id ? "Unlink" : "Link"}
                                  </MenuItem>
                                )}
                              </TextField>
                            </Button>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          ) : (
            <h6 style={{ fontFamily: "Roboto" }}>No device added yet</h6>
          )}
        </Box>

        <Pagination
          count={totalpage}
          page={page}
          variant="outlined"
          color="primary"
          onChange={handlePagechange}
        />
        <NotificationContainer />
      </Box>
      <Dialog
        open={open}
        onClose={() => {
          setupdate_device(resetdata);
          setopen(false);
        }}
      >
        <DialogTitle>Add Device</DialogTitle>
        <DialogContent>
          <TextField
            select
            label="Select Model"
            name="device_group"
            id="deviceName"
            sx={{ width: "100%", maxWidth: "400px", marginTop: "0.3125rem" }}
            variant="outlined"
            value={update_device.model_number}
            onChange={handleChange2}
          >
            {model &&
              model
                .filter((i) => {
                  if (i.device_type === "BLUETOOTH") {
                    return i;
                  }
                })
                .map((i) => {
                  return <MenuItem value={i.id}>{i.model_number}</MenuItem>;
                })}
          </TextField>

          <TextField
            label="Device Name"
            name="device_name"
            id="outlined-multiline-flexible"
            sx={{ width: "100%", maxWidth: "400px", marginTop: "0.4375rem" }}
            variant="outlined"
            value={update_device.device_name}
            onChange={handleChange2}
          />

          <TextField
            id="outlined-multiline-flexible"
            label="Enter Bluetooth Id"
            name="mac_address"
            sx={{ width: "100%", maxWidth: "400px", marginTop: "0.4375rem" }}
            value={update_device.mac_address}
            onChange={(e) => {
              handleChange2(e);
            }}
          />

          <TextField
            name="comments"
            variant="outlined"
            label="Comments"
            sx={{ width: "100%", maxWidth: "400px", marginTop: "0.4375rem" }}
            onChange={handleChange2}
          ></TextField>

          {/* <TextField
            id="outlined-select"
            select
            label="Select Billing Type"
            sx={{ width: "400px", marginTop: "7px" }}
            name="billing_type_id"
            onChange={handleChange2}
            required
          >
            {billingType.map((type) => (
              <MenuItem key={type.id} value={type.id}>
                {type.name}
              </MenuItem>
            ))}
          </TextField> */}

          {/* {isAdmin && (
            <TextField
              id="outlined-select"
              select
              label="Select Free Period"
              sx={{ width: "400px", marginTop: "7px" }}
              name="free_period"
              onChange={handleChange2}
              required
            >
              {freePeriodType.map((type) => (
                <MenuItem key={type.id} value={type.id}>
                  {type.free_time_period} month
                </MenuItem>
              ))}
            </TextField>
          )} */}

          <Box>
            Active Status:
            <Switch
              checked={update_device.active_status}
              onChange={handleChange2}
              name="active_status"
              inputProps={{ "aria-label": "controlled" }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            sx={buttonStyle3}
            onClick={() => {
              handleSubmit();
            }}
          >
            Add
          </Button>
          <Button
            variant="contained"
            color="error"
            sx={buttonStyle3}
            onClick={() => {
              setupdate_device(resetdata);
              setopen(false);
            }}
          >
            cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
